// src/api/productSearchApi.ts
import { http } from "./http";

export type ProductLite = {
  id: number;
  name: string;
  price: string | number; // display price (min variant price if present, else product price)
  image_url: string | null;
  min_variant_price?: string | number | null;
};

type SearchRow = {
  product_id: number;
  product_name: string;
  product_image: string | null;
  product_price: string | number;
  min_variant_price: string | number | null;
};

export async function searchProducts(q: string): Promise<ProductLite[]> {
  const trimmed = q.trim();
  if (!trimmed) return [];

  const res = await http.get(`/api/search/products`, {
    params: { q: trimmed },
  });

  const rows: SearchRow[] = Array.isArray(res.data) ? res.data : [];

  return rows.map((r) => ({
    id: r.product_id,
    name: r.product_name,
    image_url: r.product_image || null,
    price: r.min_variant_price ?? r.product_price,
    min_variant_price: r.min_variant_price,
  }));
}

export async function getProductsByIds(ids: number[]): Promise<ProductLite[]> {
  if (!ids.length) return [];

  const res = await http.get(`/api/search/products/by-ids`, {
    params: { ids: ids.join(",") },
  });

  const rows: SearchRow[] = Array.isArray(res.data) ? res.data : [];

  return rows.map((r) => ({
    id: r.product_id,
    name: r.product_name,
    image_url: r.product_image || null,
    price: r.min_variant_price ?? r.product_price,
    min_variant_price: r.min_variant_price,
  }));
}
